module.exports = __webpack_public_path__ + "ad4bcd25.svg";